/**
 * #1316 — `SessionScope` remounts what it wraps when the session epoch changes (`sessionEnded.ts`: an account change or
 * an identity switch), so no state, effect or cache held by a component of the old session reaches the new one. A
 * `scopeKey` remounts it too (a caller's own boundary — e.g. the tenant in view).
 */
import { Fragment, useSyncExternalStore, type ReactElement, type ReactNode } from 'react'
import { onSessionEpochChange, sessionEpoch } from './sessionEnded'

/** The current session epoch; re-renders on each bump. */
export function useSessionEpoch(): number {
  return useSyncExternalStore(onSessionEpochChange, sessionEpoch)
}

export function SessionScope({ children, scopeKey = '' }: { children: ReactNode; scopeKey?: string }): ReactElement {
  const epoch = useSessionEpoch()
  return <Fragment key={`${scopeKey}:${epoch}`}>{children}</Fragment>
}
